const BASE_URL = '/common/cookies_consent_categories'

export const cookiesConsentsCategoriesApi = ({ GET }) => ({
  fetchList: (data) => GET(BASE_URL, data),
})
